import { v4 } from 'uuid';

/**
 * Random UUID for new records, mutations and files. `crypto.randomUUID` only
 * exists in secure contexts (HTTPS or localhost), but family devices on a LAN
 * reach the dev server over plain http, so this goes through the uuid package,
 * which falls back to `crypto.getRandomValues` (available everywhere).
 */
export function newId(): string {
  return v4();
}
